import { useEffect } from 'react'
import { AdId } from './useAdConfigs'

const globalRenderCallbacks: {
  id: AdId
  callback: (event: googletag.events.SlotRenderEndedEvent) => void
}[] = []
export const useGoogleAds = () => {
  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] }
    // Only initialize pubads services once
    if (window.pubadsReshetReady) {
      return
    }
    window.pubadsReshetReady = true
    window.googletag.cmd.push(() => {
      /**
       *  Event listeners can be implemented as per reference
       *  https://developers.google.com/publisher-tag/samples/ad-event-listeners
       */

      //googletag.pubads().addEventListener('slotOnload', event => {})
      window.googletag.pubads().addEventListener('slotRenderEnded', event => {
        const slotId = event.slot.getSlotElementId()
        const callback = globalRenderCallbacks.find(
          callback => callback.id === slotId
        )
        callback && callback.callback(event)
      })

      // 3. הפעלת השירותים
      // window.googletag.enableServices() // done in GoogleAdContext
    })
  }, [])
  return { renderCallbacks: globalRenderCallbacks }
}
